import { createFileRoute } from '@tanstack/react-router'

import { SettingsPage } from '@/pages/settings/SettingsPage.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/settings/bucket-mount/',
)({
  component: SettingsPage,
})
